import styled from "styled-components"

export const Bold = styled.strong`
	font-weight: bold;
`
